const templateUrl = require('./spinner-overlay.html');

module.exports = {
  templateUrl: templateUrl,
  controller: require('./spinner-overlay.controller'),
  bindings: {
    expression: '<ogWhile'
  }
};
